import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, asapScheduler } from 'rxjs'
import { observeOn } from 'rxjs/operators'

export interface PageTitleConfig {
  icon: string
  title: string
}

/**
 * Drives the shell header's `<div id="page-title">` element. Each routed page calls
 * `pageTitle.set(icon, title)` on init (or sets via route `data` for placeholder pages
 * — see {@link StubPageComponent}). The `<h3>` in the header has no Tailwind classes —
 * typography is handled by the global stylesheet.
 *
 * Ported from cnect-ux's `EmployerShellComponent` page-title contract.
 *
 * `observeOn(asapScheduler)` is deliberate: `set()` runs from routed components' `ngOnInit`
 * after the shell has already been checked, so a synchronous emission throws NG0100.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly titleSource = new BehaviorSubject<PageTitleConfig | null>(null)
  readonly pageTitle$: Observable<PageTitleConfig | null> = this.titleSource.pipe(observeOn(asapScheduler))

  set(icon: string, title: string): void {
    this.titleSource.next({ icon, title })
  }

  clear(): void {
    this.titleSource.next(null)
  }
}
